module.exports = __webpack_public_path__ + "img/sspoin_logo.18fb5f4c.png";